<template>
  <div class="industry-template pb-20">
    <div class="lg:max-w-7xl mx-auto px-8">
      <Crumbs :crumbs="crumbs" class="py-8" />
      <div class="block md:flex justify-between mb-20">
        <CommonRisks
          :header="industry.frame_body.header"
          :risks="industry.frame_body.subheader"
        />
        <BusinessCheckList
          :header="industry.frame_head.header"
          :checklist="industry.business_lists"
        />
      </div>
    </div>

    <Ribbon class="mb-10" />

    <WhatYouGet class="lg:max-w-4xl mx-auto mb-10" />

    <EmployeeTypes class="lg:max-w-4xl mx-auto mb-24" />

    <RegistrationPrompt
      button-id="company-size-button"
      class="mx-auto shadow-md"
    />
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  useMeta,
  useRoute,
} from '@nuxtjs/composition-api';
import Crumbs from '@/components/Crumbs.vue';
import CommonRisks from '@/modules/InformationPages/Industries/components/CommonRisks.vue';
import BusinessCheckList from '@/modules/InformationPages/Industries/components/BusinessCheckList.vue';
import Ribbon from '@/components/Ribbon.vue';
import WhatYouGet from '@/components/WhatYouGet.vue';
import EmployeeTypes from '@/components/EmployeeTypes.vue';
import RegistrationPrompt from '@/components/RegistrationPrompt';
import useGlobalSettings from '@/hooks/useGlobalSettings';

import {
  benefits,
  industries,
} from '@/modules/InformationPages/Industries/mocks/index';

export default defineComponent({
  name: 'IndustryTemplate',
  components: {
    BusinessCheckList,
    CommonRisks,
    Crumbs,
    EmployeeTypes,
    RegistrationPrompt,
    Ribbon,
    WhatYouGet,
  },
  props: {
    industryType: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const route = useRoute();
    const { setHeader } = useGlobalSettings();
    const industry = computed(() =>
      !props.industryType
        ? industries[`${route.value.params.slug}`]
        : industries.food
    );
    const crumbs = computed(() => [
      {
        label: 'Industries',
        to: '/industries',
      },
      {
        label: route?.value?.params?.slug?.split('_').join(' '),
        to: `/industries/${route.value.params.slug}`,
      },
    ]);

    setHeader({
      header: industry.value.frame_head.header,
      subheader: industry.value.frame_head.subheader,
      heroImage: industry.value.bg || null,
      metaTitle: industry.value.frame_head.header,
      registration: true,
      noHero: false,
    });

    useMeta(() => ({ title: industry.value.main_heading }));

    return {
      industry,
      bgImage: computed(() => industry.value?.bg),
      benefits,
      crumbs,
    };
  },
  head() {},
});
</script>
